import request from '@/utils/request'
export function getTemplateInfo(templateId) {
  return request({
    url:'/api/approval/template?templateId='+templateId,
    method:'get',
  })
}

export function getProcessContinuation(flowId) {
	return request({
		url: `/api/approval/get-process-continuation?flowId=${flowId}`,
		method: 'get'
	})
}
export function getApproverDetailInfo(spNo) {
  return request({
    url:'/api/approval/approver-detail?spNo='+spNo,
    method:'get',
  })
}
export function submitProcess(temId,empNo,spNo,data,flowId) {
  return request({
    url:'/api/approval/start-process?temId='+temId+'&empNo='+empNo+'&spNo='+spNo+'&flowId='+flowId,
    method:'post',
	data:data
  })
}

/**
 * 发起流程(重流程编号)
 * @param temId
 * @param empNo
 * @param spNo
 * @param data
 * @param flowId
 * @returns {AxiosPromise}
 */
export function submitProcessCopy(temId,empNo,spNo,data,flowId) {
	return request({
		url:'/api/approval/start-process-flow?temId='+temId+'&empNo='+empNo+'&spNo='+spNo+'&flowId='+flowId,
		method:'post',
		data:data
	})
}
export function sendMessage(temId,empNo,spNo,data,state,empName,flowId) {
  return request({
    url:'/api/approval/send-message?temId='+temId+'&empNo='+empNo+'&spNo='+spNo+'&state='+state+'&empName='+empName+"&flowId="+flowId,
    method:'post',
	data:data
  })
}

export function sendMessageFirstHand(temId,empNo,spNo,data,state,empName,flowId) {
	return request({
		url:'/api/approval/send-message-first?temId='+temId+'&empNo='+empNo+'&spNo='+spNo+'&state='+state+'&empName='+empName+"&flowId="+flowId,
		method:'post',
		data:data
	})
}
export function getLastFlowTemplate(id){
	return request({
		url:'/api/approval/get-last-approval-apply-table?flowId='+id,
		method:'get'
	})
}

export function getFlowTemplate(id){
	return request({
		url:'/api/approval/template-flow?flowId='+id,
		method:'get'
	})
}
export function getAdministrativeProgressive(type,ItemName,SpecificationModel,Company,UnitPrice,QueryType){
	return request({
		url:'/api/approval/get-progressive?type='+type+'&ItemName='+ItemName+'&SpecificationModel='+SpecificationModel+'&Company=' + Company +'&UnitPrice=' + UnitPrice +'&QueryType=' + QueryType,
		method:'get'
	})
}

export function getStartCounsel(empno){
	return request({
		url:'/api/counsel/'+ empno +'/start-counsel',
		method:'get'
	})
}

export function getMediaId(mediaId){
	return request({
		url:'/api/Approval/convert-file?mediaId=' + mediaId,
		method:'get'
	})
}

export function AllowApplyForVerify(flowsId,templateId){
	return request({
		url:'/api/Approval/'+flowsId+'/allow-applyfor-verify?templateId=' + templateId,
		method:'get'
	})
}

export function GetPendingProcessList(empNo){
	return request({
		url:'/api/Approval/get-pending-process-list?empNo=' + empNo,
		method:'get'
	})
}

export function GetPendingProcessById(id){
	return request({
		url:'/api/Approval/get-pending-process-by-id?id=' + id,
		method:'get'
	})
}

export function GetKing(empNo) {
  return request({
    url:'/api/Temporary/get-king?empNo='+empNo,
    method:'get'
  })
}
